import axios from 'axios';
import { ApiFund } from './model/ApiFund';
import { ApiKorpoCodeResponse } from './model/ApiKorpoCodeResponse';

export function postKorpoCode(productType: 'IKEK' | 'IKZEK', code: string): Promise<ApiKorpoCodeResponse> {
  return axios.post<ApiKorpoCodeResponse>('/api/moventum/products/korpo-product-number', {
    productType,
    code,
  }).then(result => result.data);
}

export function getApiEmployerProductFunds(productIdn: string, employerIdn?: string): Promise<ApiFund[]> {
  const url = `/api/moventum/products/${productIdn}/funds`;
  return axios.get<ApiFund[]>(url, { params: { employerIdn } }).then(result => result.data);
}
